import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./index.css";
import "./mobile-responsive.css";
import MainLandingPage from "./components/MainLandingPage";
import ThankYouPage from "./components/ThankYouPage";

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-white overflow-x-hidden">
        <Routes>
          <Route
            path="/"
            element={
              <>
                <MainLandingPage />
                {/* Footer */}
                <footer className="bg-gray-900 text-white py-8 sm:py-12">
                  <div className="container mx-auto px-4">
                    <div className="text-center">
                      <div className="flex flex-col sm:flex-row items-center justify-center mb-4 gap-3 sm:gap-0">
                        <div className="footer-logo sm:mr-5">
                          <img
                            src="/images/Real_state.png"
                            alt="Bernie Logo"
                            className="h-14 w-14 sm:h-16 sm:w-16 lg:h-18 lg:w-18 object-contain rounded-lg border border-white/20 p-2 hover:scale-105 transition-all duration-300 ease-in-out cursor-pointer"
                          />
                        </div>
                        <h2 className="logo-text text-2xl sm:text-3xl lg:text-4xl font-bold">
                          BERNADETTE HARRIS
                        </h2>
                      </div>
                      <p className="text-gray-400 mb-4 text-sm sm:text-base max-w-md mx-auto">
                        Your trusted real estate expert and first-time buyer
                        specialist
                      </p>
                      <div className="flex justify-center space-x-4 sm:space-x-6 mb-6">
                        {/* <a
                          href="https://facebook.com/realestatepro"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-gray-400 hover:text-white transition-colors text-sm sm:text-base">
                          Facebook
                        </a> */}
                        <a
                          href="https://www.instagram.com/ms.mac.realtor/"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-gray-400 hover:text-white transition-colors text-sm sm:text-base">
                          Instagram
                        </a>
                        <a
                          href="https://www.linkedin.com/in/bernadette-harris-7a1299196/"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-gray-400 hover:text-white transition-colors text-sm sm:text-base">
                          LinkedIn
                        </a>
                        {/* <a
                          href="https://twitter.com/realestatepro"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-gray-400 hover:text-white transition-colors text-sm sm:text-base">
                          Twitter
                        </a> */}
                      </div>

                      {/* Dynamic Copyright Section */}
                      <div className="border-t border-gray-700 pt-6">
                        <p className="text-gray-400 text-xs sm:text-sm">
                          © {new Date().getFullYear()} BERNADETTE HARRIS Real
                          Estate Team. All rights reserved.
                        </p>
                        <p><a href="https://turjatalukderdev.netlify.app/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors text-sm sm:text-base">Developed by Turja Talukder</a></p>
                      </div>
                    </div>
                  </div>
                </footer>
              </>
            }
          />
          <Route
            path="/thank-you"
            element={
              <>
                <ThankYouPage />
                {/* Footer for Thank You Page */}
                <footer className="bg-gray-900 text-white py-8">
                  <div className="container mx-auto px-4 text-center">
                    <div className="flex items-center justify-center mb-4">
                      <img
                        src="/images/Real_state.png"
                        alt="Bernie Logo"
                        className="h-12 w-12 object-contain rounded-lg border border-white/20 p-2 mr-3"
                      />
                      <h2 className="text-xl font-bold">BERNADETTE HARRIS</h2>
                    </div>
                    <p className="text-gray-400 text-sm mb-4">
                      © {new Date().getFullYear()} BERNADETTE HARRIS Real Estate
                      Team. All rights reserved.
                    </p>
                    <p><a href="https://turjatalukderdev.netlify.app/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors text-sm sm:text-base">Developed by Turja Talukder</a></p>
                  </div>
                </footer>
              </>
            }
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
